import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseServicoComponent } from '../../components/servicos/base-servico/base-servico.component';
import { FormularioSolicitanteComponent } from '../../components/servicos/formulario-solicitante/formulario-solicitante.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from '../../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { StepsModule } from 'primeng/steps';
import { RadioButtonModule } from 'primeng/radiobutton';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PanelModule } from 'primeng/panel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { PortalFooterComponent } from '../../components/portal-footer/portal-footer.component';
import { PortalHeaderComponent } from '../../components/portal-header/portal-header.component';
import { ConfirmacaoSolicitacaoComponent } from '../../components/servicos/confirmacao-solicitacao/confirmacao-solicitacao.component';
import { FormularioServicoComponent } from '../../components/servicos/formulario-servico/formulario-servico.component';
import { HeaderUnidadeComponent } from '../../components/servicos/header-unidade/header-unidade.component';
import { TituloComponent } from '../../components/titulo/titulo.component';
import { AgendamentoAtendimentoComponent } from '../agendamentos/atendimento/atendimento.component';
import { ListaServicosComponent } from '../categoria-servicos/lista/lista.component';
import { IndexComponent } from '../index/index.component';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { AcompanharServicoComponent } from './acompanhar-servico/acompanhar-servico.component';
import { BuscaJudicialComponent } from './busca-judicial/busca-judicial.component';
import { CredenciamentoCaminhaoLimpaFossaComponent } from './credenciamento-caminhao-limpa-fossa/credenciamento-caminhao-limpa-fossa.component';
import { CredenciamentoImobiliariasComponent } from './credenciamento-imobiliarias/credenciamento-imobiliarias.component';
import { PesquisaServicoConcluidaComponent } from './pesquisa-servico-concluida/pesquisa-servico-concluida.component';
import { PesquisaServicoErrorComponent } from './pesquisa-servico-error/pesquisa-servico-error.component';
import { PesquisaServicoComponent } from './pesquisa-servico/pesquisa-servico.component';
import { SolicitarServicoComponent } from './solicitar-servico/solicitar-servico.component';
import { ServicosRoutingModule } from './servicos-routing.module';


@NgModule({
  declarations: [
    FormularioServicoComponent,
    ListaServicosComponent,
    PageNotFoundComponent,
    AgendamentoAtendimentoComponent,
    PortalHeaderComponent,
    PortalFooterComponent,
    TituloComponent,
    SolicitarServicoComponent,
    FormularioSolicitanteComponent,
    ConfirmacaoSolicitacaoComponent,
    IndexComponent,
    AcompanharServicoComponent,
    PesquisaServicoComponent,
    PesquisaServicoConcluidaComponent,
    PesquisaServicoErrorComponent,
    BuscaJudicialComponent,
    BaseServicoComponent,
    HeaderUnidadeComponent,
    CredenciamentoCaminhaoLimpaFossaComponent,
    CredenciamentoImobiliariasComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    DropdownModule,
    CardModule,
    ConfirmDialogModule,
    DialogModule,
    MessagesModule,
    ProgressSpinnerModule,
    ToastModule,
    FileUploadModule,
    InputMaskModule,
    InputNumberModule,
    StepsModule,
    RadioButtonModule,
    KeyFilterModule,
    InputTextareaModule,
    PanelModule,
    ScrollPanelModule,
    ServicosRoutingModule
  ],
  exports: [
    FormularioServicoComponent,
    ListaServicosComponent,
    PageNotFoundComponent,
    AgendamentoAtendimentoComponent,
    PortalHeaderComponent,
    PortalFooterComponent,
    TituloComponent,
    SolicitarServicoComponent,
    FormularioSolicitanteComponent,
    ConfirmacaoSolicitacaoComponent,
    IndexComponent,
    AcompanharServicoComponent,
    PesquisaServicoComponent,
    PesquisaServicoConcluidaComponent,
    PesquisaServicoErrorComponent,
    BuscaJudicialComponent,
    BaseServicoComponent,
    HeaderUnidadeComponent,
    CredenciamentoCaminhaoLimpaFossaComponent,
    CredenciamentoImobiliariasComponent,
  ]
})
export class ServicosModule { }
